// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"93c3f747b3c160c1df96","339":"ba551adeafef75c8ec4f"}[chunkId] + ".js";
};